export default {
  common: {
    nav: {
      home: "होम",
      find_offer_help: "मदद खोजें / दें",
      celebrate: "जीवन का उत्सव",
      family_tree: "परिवार वृक्ष",
      events: "कार्यक्रम",
      civic_reports: "नागरिक रिपोर्ट",
      neighborhood_pulse: "पड़ोस की धड़कन",
      weather: "मौसम",
      nature: "प्रकृति",
      marketplace: "बाज़ार",
      news: "समाचार",
      causes: "उद्देश्य",
      more: "और",
    },
    header: { sign_in: "साइन इन", join: "Social Pulse से जुड़ें", language: "भाषा", search: "खोजें" },
    tagline: "समुदायों को जोड़ना · जीवन को सशक्त करना · सामाजिक पूंजी का निर्माण",
    locality: {
      viewing_from: "आप देख रहे हैं",
      help_improve: "अपने स्थान को बेहतर बनाने में हमारी मदद करें",
      filter_by_country: "देश के अनुसार फ़िल्टर करें",
      change: "बदलें",
      set_your_location: "अपना स्थान सेट करें",
      set_your_location_hint: "— निजीकृत करने के लिए टैप करें",
    },
    actions: {
      submit_cause: "एक उद्देश्य / अपील दर्ज करें",
      make_donation: "Social Pulse की वैश्विक पहलों का समर्थन करें — दान करें",
      browse_all: "सभी अनुभाग देखें",
    },
    news: {
      title: "आपकी दैनिक ब्रीफिंग।",
      submit_news: "समाचार भेजें",
      archive: "संग्रह",
      weather_nature: "मौसम और प्रकृति",
      play_briefing: "दैनिक ब्रीफिंग सुनें",
      play_briefing_hint: "शीर्ष {{count}} समाचार सुनें · ~{{minutes}} मिनट · आपकी भाषा में",
      read_original: "मूल पढ़ें",
      view_brief: "संक्षेप देखें",
      also_reported_by: "इनके द्वारा भी रिपोर्ट किया गया:",
      translate: "अनुवाद करें",
      listen: "सुनें",
      stop: "रोकें",
    },
  },
};
